<template>
  <div class="continue-with-box">
    <div class="d-flex justify-content-between align-items-center">
      <div class="font-weight-bold">{{ translate('Continue with') }}</div>
      <div class="text-muted font-weight-bold">
        <div class="alert alert-info" v-if="isAllSelected  && selectedOutputs.length !== 1">
            {{ translate('All files') }}
        </div>

        <div class="alert alert-warning" v-if="isNoneSelected">
          {{ translate('No files selected') }}
        </div>

        <div class="alert alert-info" v-if="!isNoneSelected && !isAllSelected && selectedOutputs.length !== 1">
          {{ selectedOutputs.length }}  {{ translate('Files') }}
        </div>
        <div class="alert alert-info short-text-name" v-if="selectedOutputs.length === 1">
          {{ decodeUrl(this.getSingleSelectedFilename()) }}
        </div>
      </div>
    </div>
    <div class="continue-btn-box" v-if="reconvertLinks.length > 0">
      <div class="continue-btn" v-for="reconvertItem in reconvertLinks" v-bind:class="{ 'disabled': complete !== true, 'disabled': selectedOutputs.length === 0}" @click="openContinue(reconvertItem.operation)">
        <div class="d-flex gap-10px h-100">
        <div class="continue-btn-icon" :class="getIcon(reconvertItem)">
          <i class="far lh-inherit" :class="reconvertItem.icon"></i>
        </div>
        <div class="continue-btn-text">
           {{ translate(reconvertItem.name) }}
        </div>
        </div>
        <div><i class="far fa-arrow-right"></i></div>
      </div>
      <div class="continue-btn" v-bind:class="{ 'disabled': complete !== true, 'disabled': selectedOutputs.length === 0}" @click="openMore()">
        <div class="d-flex gap-10px h-100">
          <div class="continue-btn-icon text-normal">
            <i class="far fa-ellipsis-h lh-inherit" ></i>
          </div>
          <div class="continue-btn-text">
            {{ translate('more') }}
          </div>
        </div>
        <div><i class="far fa-arrow-right"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import PreviewManager from "../../manager/PreviewManager";
import Reconvert from "../../util/Reconvert";
import {EventBus} from "../../events/event.bus";
import {EVENT_APP_NAVIGATE} from "../../events/app.events";

export default {
  name: "ContinueWith",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    getIcon(reconvertItem) {
      return `bg-main-${reconvertItem.color}`
    },
    openMore() {
      this.resultPage.activeToolGroup = 'tools';
      EventBus.$emit(EVENT_APP_NAVIGATE, `/${this.currentJob.id}/tools`, {})
    },
    getSingleSelectedFilename() {
      let targetOperation = this.currentJob.apiJob.sat_links.reconvert[0];
      if (targetOperation.use_input) {
          return this.currentJob.apiJob.input[0].filename;
      } else {
        let output =  this.getOutputById(this.currentJob.id, this.selectedOutputs[0]);
        return PreviewManager.getFilenameFromOutput(output);
      }

    },
    openContinue(operation) {
      if (this.complete && this.selectedOutputs.length > 0) {
        Reconvert.continueWithSelected(this.currentJob, operation);
      }
    },
    decodeUrl(url) {
      try {
        return decodeURIComponent(url);
      } catch (e) {
        return url;
      }
    }
  },
  computed: {
    reconvertLinks() {
      return Reconvert.getReconvertList(this.currentJob);
    }
  },
  filters: {


  },
};
</script>
<style lang="scss" scoped>
.continue-btn-icon {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  border-radius: 4px;
  color: white;
}
.short-text-name {
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.alert {
  font-size: 12px;
  padding: 5px 5px;
  margin: 0;
}
.continue-with-box {
  display: flex;
  flex-direction:column;
  gap: 20px;
}
.continue-btn-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.disabled {
  opacity: .5;
  cursor: not-allowed !important;
}

.continue-btn {
  overflow:hidden;
  display: flex;
  background: #F8F9FA;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  justify-content: space-between;
  padding: 5px 20px 5px 5px;
  height: 42px;
  align-items: center;
  cursor: pointer;

  .dark-mode & {
    background:#383838;;
    border: 1px solid #595959;
    color: white;
    &:hover {
      background: #323232;
    }
  }

  &:hover {
    background: #F2F2F2;
  }

  .continue-btn-text {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}
</style>
